/* Location: assets/mr26-header.js
 * What: Accessible shared navigation lifecycle.
 * Why: Keep menus working after theme-editor section replacement.
 * Related: sections/mr26-header.liquid, assets/mr26-header.css */
if (!customElements.get('mr26-site-header')) {
  customElements.define('mr26-site-header', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('.mr26-header-open');
      this.dialog = dialog;
      if (!dialog || !trigger) return;
      let closeAnimation;
      const close = () => {
        if(!dialog.open||closeAnimation)return;
        if(matchMedia('(prefers-reduced-motion: reduce)').matches){dialog.close();return;}
        closeAnimation=dialog.animate([{transform:'translateX(0)'},{transform:'translateX(-105%)'}],{duration:300,easing:'ease-out'});
        closeAnimation.onfinish=()=>{dialog.close();closeAnimation=null;};
      };
      dialog.addEventListener('cancel',event=>{event.preventDefault();close();},options);
      trigger.addEventListener('click', () => {dialog.querySelectorAll('.mr26-nav-details').forEach(item=>item.open=false);this.style.transform='translateY(0)';dialog.showModal();trigger.setAttribute('aria-expanded','true');}, options);
      this.querySelector('.mr26-header-close').addEventListener('click',close,options);
      dialog.addEventListener('close',()=>{trigger.setAttribute('aria-expanded','false');trigger.focus();},options);
      dialog.addEventListener('click',event=>{if(event.target===dialog || event.target.closest('a'))close();},options);
      this.querySelectorAll('details').forEach(details=>details.addEventListener('toggle',()=>{
        if(details.open){const scope=details.classList.contains('mr26-nav-group')?details.parentElement:details.closest('nav');scope?.querySelectorAll(details.classList.contains('mr26-nav-group')?'.mr26-nav-group':'.mr26-nav-details').forEach(other=>{if(other!==details)other.open=false;});}
      },options));
      this.querySelectorAll('.mr26-header-desktop .mr26-nav-entry').forEach(entry=>{
        const details=entry.querySelector('details');if(!details)return;
        let closeTimer;
        const cancelClose=()=>{clearTimeout(closeTimer);closeTimer=null;};
        this.abort.signal.addEventListener('abort',cancelClose,{once:true});
        entry.addEventListener('pointerenter',cancelClose,options);
        entry.querySelector('.mr26-nav-label').addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){cancelClose();details.open=true;}},options);
        entry.addEventListener('pointerleave',event=>{
          if(event.pointerType!=='mouse')return;
          cancelClose();
          closeTimer=setTimeout(()=>{
            closeTimer=null;
            const focused=document.activeElement;
            if(entry.contains(focused)&&focused.matches(':focus-visible'))return;
            details.open=false;
          },180);
        },options);
        entry.addEventListener('focusout',event=>{if(!entry.contains(event.relatedTarget))details.open=false;},options);
      });
      document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!dialog.open)this.querySelectorAll('details[open]').forEach(details=>{details.open=false;details.querySelector('summary').focus();});},options);
      document.addEventListener('click',event=>{if(!this.contains(event.target))this.querySelectorAll('details[open]').forEach(details=>details.open=false);},options);
      document.addEventListener('cart:change',event=>{const count=event.detail?.cart?.item_count;if(count!==undefined)this.querySelectorAll('.mr26-header-cart-dot').forEach(dot=>dot.hidden=count===0);},options);
      const update=()=>this.toggleAttribute('scrolled',Math.max(0,scrollY)>0);
      addEventListener('scroll',update,{...options,passive:true});update();
      this.media=matchMedia('(min-width:1200px)');
      this.media.addEventListener('change',()=>{if(dialog.open)close();this.querySelectorAll('details[open]').forEach(details=>details.open=false);},options);
      this.resize=new ResizeObserver(()=>document.documentElement.style.setProperty('--header-height',`${this.offsetHeight}px`));
      this.resize.observe(this);
      document.addEventListener('shopify:block:select',event=>{
        if(this.contains(event.target)){const details=event.target.querySelector('details');if(details)details.open=true;}
      },options);
    }
    disconnectedCallback(){if(this.dialog?.open)this.dialog.close();this.abort?.abort();this.resize?.disconnect();}
  });
}
